import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { LANGS, pathFor } from "@/i18n/routes";

export const LangSwitcher = ({ compact = false, onPick, idPrefix = "header" }) => {
  const { lang, pageKey } = useLang();
  const navigate = useNavigate();
  const pick = (l) => {
    if (l !== lang) navigate(pathFor(l, pageKey === "notFound" ? "home" : pageKey) + window.location.search);
    if (onPick) onPick();
  };
  return (
    <div role="group" aria-label="Language" className="flex items-center rounded-full bg-white/70 p-1 shadow-[inset_0_0_0_1px_var(--line)]" data-testid={`${idPrefix}-lang-switcher`}>
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          onClick={() => pick(l)}
          aria-pressed={l === lang}
          data-testid={`${idPrefix}-lang-${l}`}
          className={`flex items-center gap-1.5 rounded-full ${compact ? "px-2 py-1.5" : "px-2.5 py-1.5"} text-xs font-bold tracking-wider transition-colors duration-300 ${l === lang ? "bg-[var(--green-deep)] text-white" : "text-[var(--ink)] hover:bg-[var(--green-pale)]"}`}
        >
          {!compact && <span className={`flag flag-${l}`} aria-hidden="true" />}
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
